// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AccessContainer component
 */

!(function () {

  var React = require('react');
  var AccessHeader = require('./Izenda.AccessHeader');
  var AccessBody = require('./Izenda.AccessBody');
  var connect = require('share/enhancers/Izenda.Connect');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');

  var AccessContainer = React.createClass({

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    /**
     * render component
     * @return {Object} react component
     */
    render: function () {
      var props = this.props;

      return (
        <div className="izenda-Wrapper-content">
          <ScrollBox>
            <div className="u_fullHeight u_paddingLeftRight">
              <AccessHeader {...props} />
              <AccessBody {...props} accessStore={props.store.accessStore} />
            </div>
          </ScrollBox>
        </div>
      );
    }
  });

  module.exports = connect()(AccessContainer);
} ());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Access/Izenda.AccessContainer.jsx